import styled from 'styled-components';
import Button from 'shared/ui/Button';

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: end;
  & > *:not(:last-child) {
    margin-right: 13px;
  }
`;

Wrapper.displayName = 'Wrapper';

export const CustomButton = styled(Button).attrs({ variant: 'secondary' })`
  min-width: 100px;
  color: ${({ theme }) => theme.text.detailModalButtons};
`;

CustomButton.displayName = 'CustomButton';
